"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedState = void 0;
const react_1 = require("react");
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const use_once_1 = require("./use-once");
const useDebouncedState = (debounceTime, defaultValue) => {
    const [value, setFinalValue] = (0, react_1.useState)(defaultValue);
    const [displayValue, setDisplayValue] = (0, react_1.useState)(defaultValue);
    const [debouncedSet, setDebouncedSet] = (0, react_1.useState)(() => setFinalValue);
    (0, use_once_1.useOnce)(() => setDebouncedSet(() => (0, lodash_debounce_1.default)(setFinalValue, debounceTime)));
    const setValue = (value) => {
        setDisplayValue(value);
        debouncedSet(value);
    };
    return [value, setValue, displayValue];
};
exports.useDebouncedState = useDebouncedState;
//# sourceMappingURL=use-debounced-state.js.map